import { Card, CardContent } from "@mui/material";

export const TilleyArcPlcCard = ({ customContent }) => {
  return (
    <Card className="arc-plc-card">
      <CardContent>{customContent}</CardContent>
    </Card>
  );
};
